import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderProfitService {
  constructor(private http: HttpClient) { }

  // 🟢 جلب أرباح الأوردرات حسب المخزن
  getProfitsByWarehouse(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10,
    sync: boolean = false,
    year?: number,
    month?: number
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString())
      .set('sync', sync ? '1' : '0');

    if (year) params = params.set('year', year.toString());
    if (month) params = params.set('month', month.toString());

    return this.http.get(
      `${environment.Server_URL}/order-profits/warehouse/${warehouseId}`,
      { params }
    );
  }

  // 🟢 يعمل Sync / Recalculate لأرباح مخزن كامل
  syncProfitsByWarehouse(warehouseId: number): Observable<any> {
    return this.http.post(
      `${environment.Server_URL}/order-profits/warehouse/${warehouseId}/sync`,
      {}
    );
  }

  // 🟢 جلب الأرباح مع حسابها في نفس الطلب
  getProfitsByWarehouseWithSync(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10
  ): Observable<any> {
    return this.getProfitsByWarehouse(warehouseId, page, perPage, true);
  }
  getProfitsByWarehouseMonthYear(
  warehouseId: number,
  month: number,
  year: number,
  page: number = 1,
  perPage: number = 10,
  sync: boolean = false
): Observable<any> {
  const params = new HttpParams()
    .set('month', month.toString())
    .set('year', year.toString())
    .set('page', page.toString())
    .set('per_page', perPage.toString())
    .set('sync', sync ? '1' : '0');

  return this.http.get(
    `${environment.Server_URL}/order-profits/warehouse/${warehouseId}/filter`,
    { params }
  );
}
}
